import AdviserDeclarationValidation from './AdviserDeclarationValidation'
import AdviserDetailsValidation from './AdviserDetailsValidation'
import CKAValidation from './CKAValidation'
import ClientDeclarationValidation from './ClientDeclarationValidation'
import DependantValidation from './DependantValidation'
import ExistingPortfolioDeclarationValidation from './ExistingPortfolioDeclarationValidation'
import ExistingPortfolioValidation from './ExistingPortfolioValidation'
import ExistingInvestmentDeclarationValidation from './ExistingInvestmentDeclarationValidation'
import ExistingInvestValidation from './ExistingInvestValidation'
import ILPPortfolioValidation from './ILPPortfolioValidation'
import PersonalDetailsValidation from './PersonalDetailsValidation'
import RecommendationBasisValidation from './RcmdBasisValidation'
import RPAValidation from './RPAValidation'
import SwitchingValidation from './SwitchingValidation'
import ThirdPartyPayorValidation from './ThirdPartyPayorValidation'
import TrustedIndividualValidation from './TrustedIndividualValidation'
import SharedRcmdBasisValidation from './SharedRcmdBasisValidation'
import SharedCKAValidation from './SharedCKAValidation'
import RcmdValidation from './RcmdValidation'
import BasicProductValidation from './BasicProductValidation'
import SavingsNeedsValidation from './SavingsNeedsValidation'
import RetirementNeedsValidation from './RetirementNeedsValidation'
import InvestmentNeedsValidation from './InvestmentNeedsValidation'
import EducationNeedsValidation from './EducationNeedsValidation'
import LongTermNeedsValidation from './LongTermNeedsValidation'
import DisabilityProtectionValidation from './DisabilityProtectionValidation'
import DisabilityIncomeProtectionValidation from './DisabilityIncomeProtectionValidation'
import DeathProtectionValidation from './DeathProtectionValidation'
import CriticalIllnessValidation from './CriticalllnessValidation'
import OtherNeedsValidation from './OtherNeedsValidation'
import HospitalizationNeedsValidation from './HospitalizationValidation'
import PersonalAccidentNeedsValidation from './PersonalAccidentValidation'
import DependantProtectionNeedsValidation from './DependantProtectionNeedsValidation'
import ECDDValidation from './ECDDValidation'
import NetWorthValidation from './NetWorthValidation'
import CashFlowValidation from './CashFlowValidation'
import BudgetValidation from './BudgetValidation'
import BeneficialOwnerValidation from './BeneficialOwnerValidation'
import IdentifyingYourPriorities from './IdentifyingYourPriorities'
import AMLValidation from './AMLValidation'

export default class KYCValidators {
  personalDetails = new PersonalDetailsValidation()
  dependant = new DependantValidation()
  clientDeclaration = new ClientDeclarationValidation()
  trustedIndividual = new TrustedIndividualValidation()
  thirdParty = new ThirdPartyPayorValidation()
  switching = new SwitchingValidation()
  rpa = new RPAValidation()
  basis = new RecommendationBasisValidation()
  ilpPortfolio = new ILPPortfolioValidation()
  existingPorfolioDeclaration = new ExistingPortfolioDeclarationValidation()
  existingPortfolio = new ExistingPortfolioValidation()
  existingInvestmentDeclaration = new ExistingInvestmentDeclarationValidation()
  existingInvest = new ExistingInvestValidation()
  cka = new CKAValidation()
  adviserDetails = new AdviserDetailsValidation()
  adviserDeclaration = new AdviserDeclarationValidation()
  recommendations = new RcmdValidation()
  products = new BasicProductValidation()
  beneficialOwner = new BeneficialOwnerValidation()

  // FNA
  identifyingYourPriorities = new IdentifyingYourPriorities()
  savingNeeds = new SavingsNeedsValidation()
  retirementNeeds = new RetirementNeedsValidation()
  investmentNeeds = new InvestmentNeedsValidation()
  educationNeeds = new EducationNeedsValidation()
  longTermNeeds = new LongTermNeedsValidation()
  disabilityProtection = new DisabilityProtectionValidation()
  disabilityIncomeProtection = new DisabilityIncomeProtectionValidation()
  deathProtection = new DeathProtectionValidation()
  criticalIllness = new CriticalIllnessValidation()
  otherNeeds = new OtherNeedsValidation()
  hospitalizationNeeds = new HospitalizationNeedsValidation()
  personalAccidentNeeds = new PersonalAccidentNeedsValidation()
  dependentsProtection = new DependantProtectionNeedsValidation()
  aml = new AMLValidation()
  ecdd = new ECDDValidation()
  netWorth = new NetWorthValidation()
  cashFlow = new CashFlowValidation()
  budget = new BudgetValidation()

  // Shared validators
  sharedRcmdBasis = new SharedRcmdBasisValidation()
  sharedCka = new SharedCKAValidation()
}
